import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageListConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DialogService} from "@progress/kendo-angular-dialog";
import {SharedService} from "../../shared/shared.service";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {SettingsPlannerService} from "./settings-planner.service";
import {PageListComponent} from "../../../fw/pages/page-list.component";
import {Router} from "@angular/router";
import {DtoPlannerSettingsUser} from "./models/DtoPlannerSettingsUser";
import {FormService} from "../../../fw/services/form.service";
import {DtoInactivityList} from "./models/DtoInactivityList";
import {InactivityComponent} from "./inactivity.component";
import {DtoAppointmentLabel} from "./models/DtoAppointmentLabel";
import {AppointmentlabelComponent} from "./appointmentlabel.component";
import {DtoAppointmentKindList} from "./models/DtoAppointmentKindList";
import {AppointmentkindComponent} from "./appointmentkind.component";
import {AppointmentkindCombinationComponent} from "./appointmentkind-combination.component";

@Component({
    selector: 'app-settings-planner',
    template: require('./settings-planner.component.html'),
    styles: [require('./settings-planner.component.css')]
})

@AutoUnsubscribe()
export class SettingsPlannerComponent implements OnInit {
    @ViewChild('gridAppointmentKind', {static: false}) gridAppointmentKind: DynamicGridComponent;
    @ViewChild('pageInactivities', {static: false}) pageInactivities: PageListComponent;
    @ViewChild('pageAppointmentLabels', {static: false}) pageAppointmentLabels: PageListComponent;

    dtoPlannerGeneral: DtoPlannerSettingsUser;
    formGeneral: FormGroup;
    inactivities: DtoInactivityList[];
    appointmentLabels: DtoAppointmentLabel[];
    appointmentKinds: DtoAppointmentKindList[];
    configInactivities: PageListConfig;
    configAppointmentLabels: PageListConfig;

    filterHeaderConfig: PageHeaderBarConfig;
    appointmentKindFilterForm: FormGroup;
    pshbAppointmentKindConfig: PageSubheaderBarConfig;
    pshbGeneralConfig: PageSubheaderBarConfig;
    appointmentKindColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'appointmentLabelDisplayName',
            color: 'appointmentLabelColor',
            label: 'Soort',
            type: 'color',
            width: '*'
        },
        {
            key: 'duration',
            label: 'Duur',
            type: 'string',
            width: '100px'
        },
        {
            key: 'extension',
            label: 'Uitloop',
            type: 'string',
            width: '100px'
        },
        {
            key: 'showInAgenda',
            label: 'Tonen',
            type: 'boolean',
            width: '100px'
        },
        {
            key: 'showInOnlineAgenda',
            label: 'Online tonen',
            type: 'boolean',
            width: '140px'
        }
    ];

    yesNoItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    plannerIntervalItems: Array<{ text: string, value: number }> = [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "15", value: 15 },
        { text: "20", value: 20 },
        { text: "25", value: 25 },
        { text: "30", value: 30 },
        { text: "35", value: 35 },
        { text: "40", value: 40 },
        { text: "45", value: 45 },
        { text: "50", value: 50 },
        { text: "55", value: 55 },
        { text: "60", value: 60 },
        { text: "65", value: 65 },
        { text: "70", value: 70 },
        { text: "75", value: 75 },
        { text: "80", value: 80 },
        { text: "85", value: 85 },
        { text: "90", value: 90 }
    ];
    plannerIntervalSpaceItems: Array<{ text: string; value: number }> = [
        {text: '', value: null},
        {text: '5', value: 5},
        {text: '10', value: 10},
        {text: '15', value: 15},
        {text: '20', value: 20},
        {text: '25', value: 25},
        {text: '30', value: 30},
        {text: '35', value: 35},
        {text: '40', value: 40},
        {text: '45', value: 45},
        {text: '50', value: 50},
        {text: '55', value: 55},
        {text: '60', value: 60},
        {text: '65', value: 65},
        {text: '70', value: 70},
        {text: '75', value: 75},
        {text: '80', value: 80},
        {text: '85', value: 85},
        {text: '90', value: 90}
    ];
    workweekItems: Array<{ text: string, value: number }> = [
        { text: "Maandag-Vrijdag", value: 1 },
        { text: "Maandag-Zaterdag", value: 3 },
        { text: "Maandag-Zondag", value: 4 },
        { text: "Dinsdag-Zaterdag", value: 2 }
    ];
    reminderItems: Array<{ text: string, value: number }> = [
        { text: "24 uur", value: 1 },
        { text: "48 uur", value: 2 }
    ];
    cancelItems: Array<{ text: string, value: number }> = [
        { text: "Nee", value: 0 },
        { text: "Ja, tot 24 uur van tevoren", value: 1 },
        { text: "Ja, tot 48 uur van tevoren", value: 2 }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ds: SettingsPlannerService,
                private ss: SharedService,
                private fs: FormService,
                private dialogService: DialogService,
                private router: Router) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            {text: 'hoofdmenu', isLastStep: false},
            {text: 'instellingen', isLastStep: false},
            {text: 'agenda instellingen', isLastStep: true}];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');

        this.pshbGeneralConfig = {
            title: '',
            buttonDefinition: [
                {
                    clickEventType: 'save',
                    description: 'OPSLAAN',
                    isSmall: false
                },
                {
                    clickEventType: 'cancel',
                    description: 'ANNULEREN',
                    isSmall: false
                }
            ]
        };

        this.filterHeaderConfig = {
            title: 'ZOEKOPTIES',
            buttonDefinition: [
                {
                    description: 'ZOEKEN',
                    clickEventType: 'search',
                    isSmall: false
                },
                {
                    description: 'WISSEN',
                    clickEventType: 'clear',
                    isSmall: false
                }
            ]
        };

        this.appointmentKindFilterForm = this.fb.group({
            description: '',
            showInactive: false
        });

        this.pshbAppointmentKindConfig = {
            title: 'BEHANDELINGEN',
            buttonDefinition: [
                {
                    clickEventType: 'create',
                    description: 'TOEVOEGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'createCombination',
                    description: 'COMBINATIE',
                    isSmall: false
                },
                {
                    clickEventType: 'copy',
                    description: 'KOPIËREN',
                    isSmall: false
                },
                {
                    clickEventType: 'edit',
                    description: 'WIJZIGEN',
                    isSmall: false
                },
                {
                    clickEventType: 'delete',
                    description: 'VERWIJDEREN',
                    isSmall: false
                }
            ]
        };

        this.configInactivities = {
            pageHeaderBarConfig: {
                title: '(IN)ACTIVITEITEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'dateTime',
                    label: 'Datum',
                    type: 'date',
                    width: '160px',
                    format: '{0:dd-MM-yyyy}'
                },
                {
                    key: 'from',
                    label: 'Van',
                    type: 'string',
                    width: '100px'
                },
                {
                    key: 'to',
                    label: 'Tot',
                    type: 'string',
                    width: '100px'
                },
                {
                    key: 'present',
                    label: 'Aanwezig',
                    type: 'boolean',
                    width: '100px'
                },
                {
                    key: 'reason',
                    label: 'Reden',
                    type: 'string',
                    width: '*'
                }
            ],
            rowKey: 'id'
        };

        this.configAppointmentLabels = {
            pageHeaderBarConfig: {
                title: 'BEHANDELSOORTEN',
                buttonDefinition: [
                    {
                        clickEventType: 'create',
                        description: 'TOEVOEGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'copy',
                        description: 'KOPIËREN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'edit',
                        description: 'WIJZIGEN',
                        isSmall: false
                    },
                    {
                        clickEventType: 'delete',
                        description: 'VERWIJDEREN',
                        isSmall: false
                    }
                ]
            },
            columnDefinition: [
                {
                    key: 'displayName',
                    label: 'Omschrijving',
                    type: 'string',
                    width: '*'
                },
                {
                    key: 'color',
                    color: 'color',
                    textColor: 'color',
                    label: 'Kleur',
                    type: 'color',
                    width: '100px'
                },
                {
                    key: 'isActive',
                    label: 'Actief',
                    type: 'boolean',
                    width: '100px'
                }
            ],
            rowKey: 'id'
        };

        this.formGeneral = this.fb.group({
            plannerInterval: null,
            onlinePlannerToday: null,
            userSetting: this.fb.group({
                id: null,
                workWeekType: null,
                appointmentReminderPeriod: null,
                plannerDragDrop: null,
                useAppointmentMadeBy: null,
                useNoteColumn: null,
                onlinePlannerInterval: null,
                onlinePlannerMaxWeeks: null,
                standardColor1: null,
                allowOnlineNewCustomer: null,
                disableOnlineBookingRemarks: null,
                appointmentCancelByCustomer: null,
                adwordsTag: null,
                bookingTerms: null,
                onlineBookingTerms: null,
                minIntervalBetweenOnlineBooking: null,
                onlineBookingRedirectUrl: null,
                noGroupingOnlineBooking: null,
                onlineCombiBookingOneEmployee: null,
                noLoginOnlineBooking: null,
                noEmployeeSelectionOnlineBooking: null,
                allowJoiningBookingsWithMinInterval: null
            })
        });

        this.formGeneral.get('userSetting.onlinePlannerMaxWeeks').valueChanges.subscribe(newVal => {
            if (newVal == null || newVal === '-' || newVal < 0) {
                this.formGeneral.patchValue({userSetting: {onlinePlannerMaxWeeks: 0}});
            } else if (newVal > 52) {
                this.formGeneral.patchValue({userSetting: {onlinePlannerMaxWeeks: 52}});
            }
        });

        this.ds.getAppointmentKindBaseItems(true).subscribe();
    }

    ngAfterViewInit() {
        this.loadGeneral(false);
    }

    tabSelected(e) {
        if (e.index == 0) {
            this.loadGeneral(false);
        } else if (e.index == 1) {
            this.loadInactivities(false);
        } else if (e.index == 2) {
            this.loadAppointmentLabels(false);
        } else if (e.index == 3) {
            this.loadAppointmentKinds(false);
        }
    }

    // General
    loadGeneral(reload: boolean) {
        if (reload || !this.dtoPlannerGeneral) {
            this.ds.getPlannerSettingsGeneral()
                .subscribe(response => {
                    this.dtoPlannerGeneral = response;
                    this.fs.patchDtoToForm(this.dtoPlannerGeneral, this.formGeneral);
                });
        }
    }

    phbGeneralBtnClicked(event) {
        if (event == 'cancel') {
            this.router.navigate(['/auth/home']);
        } else if (event == 'save') {
            let result = this.fs.patchFormToDto(this.dtoPlannerGeneral, this.formGeneral);
            this.ds.savePlannerSettingsGeneral(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.router.navigate(['/auth/home']);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    getStandardColor1(): string {
        if (this.formGeneral && this.formGeneral.get('userSetting.standardColor1').value)
            return this.formGeneral.get('userSetting.standardColor1').value;
        else
            return '#ffffff';
    }

    onStandardColor1PickerChange(colorCode: string) {
        this.formGeneral.patchValue({ userSetting: { standardColor1: colorCode} });
        this.formGeneral.markAsDirty();
        this.formGeneral.markAsTouched();
    }

    // Inactivities
    loadInactivities(reload: boolean) {
        if (reload || !this.inactivities) {
            this.ds.getInactivities()
                .subscribe(response => {
                    this.inactivities = response;
                    this.pageInactivities.grid.showData(this.inactivities);
                });
        }
    }

    pageInactivitiesBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showInactivityEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageInactivities.grid.getSelectedId() > 0) {
                this.showInactivityEditWindow(this.pageInactivities.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageInactivities.grid.getSelectedId() > 0) {
                this.showInactivityEditWindow(0, this.pageInactivities.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageInactivities.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteInactivityById(this.pageInactivities.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadInactivities(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageInactivitiesGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showInactivityEditWindow(event, 0);
        }
    }

    showInactivityEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: InactivityComponent
        });

        const dialogContent: InactivityComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadInactivities(true);
                }
            });
    }

    // AppointmentLabels
    loadAppointmentLabels(reload: boolean) {
        if (reload || !this.appointmentLabels) {
            this.ds.getAppointmentLabels()
                .subscribe(response => {
                    this.appointmentLabels = response;
                    this.appointmentLabels.forEach(item => {
                        item.color = this.ss.removeColorAlpha(item.color);
                    });
                    this.pageAppointmentLabels.grid.showData(this.appointmentLabels);
                });
        }
    }

    pageAppointmentLabelsBtnHeaderBarClicked(event) {
        if (event == 'create') {
            this.showAppointmentLabelEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.pageAppointmentLabels.grid.getSelectedId() > 0) {
                this.showAppointmentLabelEditWindow(this.pageAppointmentLabels.grid.getSelectedId(), 0);
            }
        } else if (event == 'copy') {
            if (this.pageAppointmentLabels.grid.getSelectedId() > 0) {
                this.showAppointmentLabelEditWindow(0, this.pageAppointmentLabels.grid.getSelectedId());
            }
        } else if (event == 'delete') {
            if (this.pageAppointmentLabels.grid.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteAppoinmentLabelById(this.pageAppointmentLabels.grid.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadAppointmentLabels(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    pageAppointmentLabelsGridRowDoubleClicked(event: number) {
        if (event > 0) {
            this.showAppointmentLabelEditWindow(event, 0);
        }
    }

    showAppointmentLabelEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: AppointmentlabelComponent
        });

        const dialogContent: AppointmentlabelComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadAppointmentLabels(true);
                }
            });
    }

    // AppointmentKinds
    loadAppointmentKinds(reload: boolean) {
        if (reload || !this.appointmentKinds) {
            this.ds.getAppointmentKinds()
                .subscribe(response => {
                    this.appointmentKinds = response;
                    this.appointmentKinds.forEach(item => {
                        item.appointmentLabelColor = this.ss.removeColorAlpha(item.appointmentLabelColor);
                    });
                    this.gridAppointmentKind.showData(this.appointmentKinds);
                    this.filterAppointmentKinds();
                });
        }
    }

    filterAppointmentKinds() {
        let filteredData = this.appointmentKinds;

        if (!this.appointmentKindFilterForm.get('showInactive').value) {
            filteredData = filteredData.filter(x => x.recActive);
        }
        if (this.appointmentKindFilterForm.get('description').value) {
            filteredData = filteredData.filter(x => x.description.toLowerCase().includes(this.appointmentKindFilterForm.get('description').value.toLowerCase()));
        }

        this.gridAppointmentKind.showData(filteredData);
    }

    phbAppointmentKindBtnClicked(event) {
        if (event == 'search') {
            this.filterAppointmentKinds();
        } else if (event == 'clear') {
            this.appointmentKindFilterForm.reset({ showInactive: false });
            this.filterAppointmentKinds();
        }
    }

    appointmentKindIsCombi(id: number) {
        if (this.appointmentKinds) {
            let item = this.appointmentKinds.find(x => x.id == id);
            if (item) {
                return item.isCombi;
            }
        }

        return false;
    }

    pshbAppointmentKindBtnClicked(event) {
        if (event == 'create') {
            this.showAppointmentKindEditWindow(0, 0);
        } else if (event == 'createCombination') {
            this.showAppointmentKindCombinationEditWindow(0, 0);
        } else if (event == 'edit') {
            if (this.gridAppointmentKind.getSelectedId() > 0) {
                if (this.appointmentKindIsCombi(this.gridAppointmentKind.getSelectedId())) {
                    this.showAppointmentKindCombinationEditWindow(this.gridAppointmentKind.getSelectedId(), 0);
                } else {
                    this.showAppointmentKindEditWindow(this.gridAppointmentKind.getSelectedId(), 0);
                }
            }
        } else if (event == 'copy') {
            if (this.gridAppointmentKind.getSelectedId() > 0) {
                if (this.appointmentKindIsCombi(this.gridAppointmentKind.getSelectedId())) {
                    this.showAppointmentKindCombinationEditWindow(0, this.gridAppointmentKind.getSelectedId());
                } else {
                    this.showAppointmentKindEditWindow(0, this.gridAppointmentKind.getSelectedId());
                }
            }
        } else if (event == 'delete') {
            if (this.gridAppointmentKind.getSelectedId() > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteAppoinmentKindById(this.gridAppointmentKind.getSelectedId())
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadAppointmentKinds(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridAppointmentKindRowdoubleClicked(event) {
        if (this.gridAppointmentKind.getSelectedId() > 0) {
            if (this.appointmentKindIsCombi(this.gridAppointmentKind.getSelectedId())) {
                this.showAppointmentKindCombinationEditWindow(this.gridAppointmentKind.getSelectedId(), 0);
            } else {
                this.showAppointmentKindEditWindow(this.gridAppointmentKind.getSelectedId(), 0);
            }
        }
    }

    showAppointmentKindEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: AppointmentkindComponent
        });

        const dialogContent: AppointmentkindComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadAppointmentKinds(true);
                }
            });
    }

    showAppointmentKindCombinationEditWindow(id: number, copyFromId: number) {
        const dialogRef = this.dialogService.open({
            content: AppointmentkindCombinationComponent
        });

        const dialogContent: AppointmentkindCombinationComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.copyFromId = copyFromId;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    this.loadAppointmentKinds(true);
                }
            });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/settings-planner.component.ts